<template>
  <div class="plan-container plan-container__confirm">
    <p class="title">Child QHA plan details</p>
    <p class="subtitle">You have selected the following plan to audit:</p>
    <div class="plan-list">
      <div class="table-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Service</th>
              <th>Health Professional</th>
              <th>Key Stage</th>
              <th>Primary Need</th>
              <th>Setting Name</th>
              <th>Report Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ currentPlan.internalId || currentPlan.ehcpId }}</td>
              <td>{{ currentPlan.service }}</td>
              <td>{{ currentPlan.healthProfessional }}</td>
              <td>{{ currentPlan.stage }}</td>
              <td>{{ currentPlan.need }}</td>
              <td>{{ currentPlan.settingName }}</td>
              <td>{{ currentPlan.reportDate | formatDate }}</td>
            </tr>
          </tbody>
        </table>
        <div class="intro-text">
          <p>
            Please ensure you have read below and aware of this information when
            completing audit:
          </p>
          <ul>
            <li>
              Audit theme (e.g. Theme 1. Timeliness &amp; Details’) is only
              saved when ‘Next Theme’ is clicked
            </li>
            <li>
              If you click from a range of grading criteria, the overall grading
              for the theme will default to the lowest criteria selected (please
              see the grading bar at the top of each theme which will indicate
              the grade applied after you have ticked criteria)
            </li>
          </ul>
        </div>
      </div>
      <div class="info-row">
        <p class="link link--back">
          <i class="fas fa-chevron-circle-left"></i>
          <a @click="$router.go(-1)">Back</a>
        </p>
      </div>
      <div class="info-row info-row--right">
        <p class="link">
          <a @click="commenceAudit">Click to begin</a>
          <i class="fas fa-chevron-circle-right"></i>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ConfirmPlan',
  computed: {
    ...mapGetters({
      currentAssignment: 'assignment/currentAssignment',
      lastSection: 'audit/lastSection',
      nextSection: 'audit/nextSection'
    }),
    currentPlan() {
      return this.currentAssignment.planId
    },
    planId() {
      return this.currentAssignment._id
    },
    assignmentId() {
      return this.currentAssignment._id
    },
    nextDisabled() {
      return !this.hasConfirmed
    }
  },
  methods: {
    ...mapActions({
      beginAudit: 'audit/beginAudit',
      continueAudit: 'audit/continueAudit',
      setDefaultGrading: 'audit/setDefaultGrading',
      checkGrading: 'audit/checkGrading',
      setCurrentAudit: 'audit/setCurrentAudit'
    }),
    async commenceAudit() {
      const assignmentId = this.assignmentId
      const planId = this.planId
      let sectionId = 'a'
      let routeObject = { name: 'Section', params: { id: sectionId } }
      if (!this.currentAssignment.startedAt) {
        await this.beginAudit({ assignmentId, planId })
        await this.setDefaultGrading()
        this.setCurrentAudit({ assignmentId })
        this.checkGrading()
      } else {
        await this.continueAudit({ assignmentId, planId })

        this.setDefaultGrading()
        sectionId =
          this.nextSection === 'additional-components'
            ? (routeObject = { name: 'Additional Components' })
            : this.nextSection === 'next-steps'
              ? (routeObject = { name: 'Next Steps' })
              : this.nextSection === undefined &&
              this.lastSection === 'next-steps'
                ? (routeObject = {
                  name: 'Audit Summary',
                  params: { id: this.nextSection }
                })
                : (routeObject = {
                  name: 'Section',
                  params: { id: this.nextSection }
                })
      }
      console.log({ routeObject })
      this.$router.push(routeObject)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/variables.scss';
@import '@/style/components.scss';
@import '@/style/sections.scss';

.hover-pointer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.hover-pointer label {
  margin: 0 0 0 0.5rem;
}

.intro-text {
  padding: 2rem;
  p {
    font-weight: 600;
  }
}

.link--back {
  z-index: 1;
}
</style>
